<thehubz-assets-control
  [configObject]="configObject"
  [assetChecked]="selectedAssets"
  [excludedAssets]="selectedAssetIds"
  [gridSettingsKeySuffix]="'AssetUploadStepper'"
  (selectedAssets)="assetsSelected($event)"
  class="makeos-asset w-full rounded-full block h-full"
></thehubz-assets-control>
